import styled from '../../../../../../../styles/styledComponents/themeComponents';

export const EventWidgetSwipeLayoutStyle = styled.div`
  width: 100%;
  position: relative;
  padding: 0 15px;

  .slick-list {
    .slick-track {
      height: auto;

      .slick-slide {
        width: 100%;

        & > div {
          width: 100%;
          overflow: hidden;

          .amondz-img {
            border-radius: 8px;
            width: 100%;
            height: auto;
          }
        }
      }
    }
  }

  .number-indicator-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 30px;
    bottom: 15px;
    background: #000000;
    border-radius: 13px;
    width: 53px;
    height: 26px;
    font-size: 13px;
    font-weight: 600;
    color: #9b9b9b;

    .current {
      color: #ffffff;
      margin-right: 1px;
    }

    .entire {
    }
  }
`;
